import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { NgIdleModule } from '@ng-idle/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TokenInterceptor } from './core/services';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { AppState, InternalStateType } from './app.service';
import { EmitService } from './ts/services/emit.service';
import { AuthGuard } from './core/guards/auth.guard';
import { VersionCheckService } from "@app/shared/versioncheck/version-check.service";
import { MomentModule } from 'ngx-moment';
import { SharedService } from './ts/services/SharedService'
import { KeyConfigService } from './keyConfig';


export function initializeApp(configService: KeyConfigService) {
  return () => configService.loadMetadata();  // Returns a function that returns a Promise
  // return () => configService.test()
}

@NgModule({
  declarations: [
    AppComponent,   
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    FormlyBootstrapModule,
    FormlyModule.forRoot(),
    NgIdleModule.forRoot(),
    MomentModule,
    HttpClientModule
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },AppState,EmitService,AuthGuard,VersionCheckService,SharedService,KeyConfigService,
   {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [KeyConfigService],
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
